<template>
    <div class="doc-download">
      <div class="box">
        <h2>Doc & Download</h2>
        <p class="subtitle">Download relevant data freely from MicroPheno database</p>
        <ul>
          <li>
            <a :href="downloadUrl+'/core_table.txt'">
              <i class="data"></i>
              <span>Association of microbe and disease</span>
              <em>core_table.txt</em>
            </a>
          </li>
          <li>
            <a :href="downloadUrl+'/EFO.txt'">
              <i class="bacteria"></i>
              <span>Disease annotation</span>
              <em>EFO.txt</em>
            </a>
          </li>
          <li>
            <a :href="downloadUrl+'/NCIT.txt'">
              <i class="disease"></i>
              <span>Microbe annotation</span>
              <em>NCIT.txt</em>
            </a>
          </li>
          <li>
            <a :href="downloadUrl+'/GeneID.txt'">
              <i class="gene"></i>
              <span>Core taxid</span>
              <em>GeneID.txt</em>
            </a>
          </li>
          <li>
            <a :href="downloadUrl+'/HV28_2.metagenome'">
              <i class="metagenome"></i>
              <span>Metagenome data</span>
              <em>HV28_2.metagenome</em>
            </a>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import API from './config/api.js';
export default {
  name: 'DocDownload',
  data(){
    return{
      downloadUrl:''
    }
  },
  created(){
      this.downloadUrl = API.downloadUrl2;
  }
}
</script>

<style scoped lang="scss">
  .doc-download{
    height:-moz-calc(100vh - 56px);
    height:-webkit-calc(100vh - 56px);
    height:calc(100vh - 56px);
    overflow-x: auto;
    padding:40px 20px;
    background: #f9f9f9;
    .box{
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      h2{
        font-size: 24px;
        color:#222222;
        text-align: center;
        margin-bottom:10px;
      }
      .subtitle{
        font-size: 16px;
        color:rgba(0,0,0,0.54);
        text-align: center;
        margin-bottom:35px;
      }
      ul{
        margin:0 -20px;
        padding:0;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        li{
          width: 20%;
          list-style: none;
          float:left;
          padding:20px;
          a{
            width: 100%;
            height:225px;
            background: #fff;
            box-shadow: 0 7px 28px 0 rgba(0,0,0,0.10);
            border-radius: 16px;
            display: block;
            padding:25px 0;
            text-align: center;
            &:hover{
              box-shadow: 0 7px 25px 0 rgba(0,0,0,0.2);
              text-decoration: none;
              i{
                width: 90px;
                height: 90px;
                margin-bottom: 10px;
              }
            }
            i{
              width: 85px;
              height: 85px;
              display: block;
              margin:0 auto;
              margin-bottom: 15px;
              &.data{
                background: url('~@/assets/images/data.svg') no-repeat center center;
                background-size: 100%;
              }
              &.bacteria{
                background: url('~@/assets/images/bacteria.svg') no-repeat center center;
                background-size: 100%;
              }
              &.disease{
                background: url('~@/assets/images/disease.svg') no-repeat center center;
                background-size: 100%;
              }
              &.gene{
                background: url('~@/assets/images/gene.svg') no-repeat center center;
                background-size: 100%;
              }
              &.metagenome{
                background: url('~@/assets/images/gene.svg') no-repeat center center;
                background-size: 100%;
              }
            }
            span{
              width: 80%;
              margin:0 auto;
              display: block;
              font-size: 16px;
              color: #0A897C;
              text-align: center;
              line-height: 20px;
              margin-bottom: 5px;
            }
            em{
              display: block;
              font-size: 12px;
              color: rgba(0,0,0,0.4);
              font-style: normal;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DocDownload.vue